import { useSuspenseQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { iamService } from '@/api/services/iam';

export function useEffectivePermissionsForAccountId(accountId: string): Set<string> {
  const { data } = useSuspenseQuery(iamService.listEffectivePermissionsQuery({ accountId }));

  return useMemo(() => new Set(data ? data.map(({ value }) => value) : []), [data]);
}
